<template>
  <div class="mt-3" v-if="ready">
    <amf-form title="Remittance Reports (All Clients)" class="container">
      <div v-if="!ready">
        Loading...
      </div>

      <div v-if="ready && this.remittanceReportsAllClients.length == 0">
        No Remittance Reports
      </div>

      <div class="remittance-report-list mt-3">
        <div v-if="ready && this.remittanceReportsAllClients.length > 0">
          <table class="table table-hover table-bordered table-sm table-reports">
            <thead>
              <th>Year</th>
              <th>Month</th>
              <th>Download</th>
            </thead>
            <tbody>
              <tr v-for="r in this.remittanceReportsAllClients" :key="`${r.remittanceYear}-${r.remittanceMonth}`">
                <td>{{ r.remittanceYear }}</td>
                <td>{{ createdMonthLongName(r.remittanceMonth) }}</td>
                <td>
                  <a href="#" @click.prevent="exportToExcel(r.remittanceYear, r.remittanceMonth)">Excel</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </amf-form>
  </div>
</template>

<script>
  import { cobraApi } from '../framework';
  import moment from 'moment'


  export default {
    props: [],
    data() {
      return {
        ready: false,
        remittanceReportsAllClients: []
      }
    },
    created() {
      this.load();
    },
    methods: {
      async load() {
        this.ready = false;
        this.remittanceReportsAllClients = await cobraApi.get(`remittance`);
        this.ready = true;
      },
      async exportToExcel(remittanceYear, remittanceMonth) {
        hj('tagRecording', ["Downloading COBRA Remittance Report"]);
        this.ready = false;
        await cobraApi.download(`remittance/${remittanceYear}/${remittanceMonth}/download`);
        this.ready = true;
      },
      createdMonthLongName(createdMonthInt) {
        return moment().month(createdMonthInt).format("MMMM");
      }
    }
  };
</script>

<style lang="scss" scoped>
  .remittance-report-list {
    height: 80%;
    overflow-y: scroll;

    a {
      color: black;
    }
  }

  .table-reports {
    th {
      text-align: center;
      padding: 6px;
      background-color: #e5e5e5;
      border: 0px;
      border-top: 1px solid #eaeaea;
      border-bottom: 1px solid #eaeaea;
    }

    td {
      text-align: center;
      padding: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/finance/RemittanceReportsAllClients.vue